import { defineStore } from 'pinia';
import { RecordItem } from '@/views/mine/types';
import { getRecord, setRecord, setCurRecord, getCurRecord } from '@/utils/storage/record';
import { getDefaultRecord, getRecordById} from '@/api/record';
import { reactive, toRefs } from 'vue'; 

interface RecordState {
  defaultRecord: RecordItem | '';
  currentRecord: RecordItem | '';
  form:{
    phone:string;
    code:string;
  }
}
export const useRecordStore = defineStore({
  id: 'app-record',
  state: (): RecordState => ({
    defaultRecord: '',
    currentRecord: '',
    form: reactive({
      phone: '',
      code: '',
    }),
  }),
  getters: {
    getForm(){
      return (this.form as any)
    },
    getDefaultRecord(): RecordItem {
      return (this.defaultRecord as any) || getRecord();
    },
    getCurrentRecord(): RecordItem {
      return this.currentRecord || getCurRecord();

    },
    getArchiveId(): number {
      if (this.getCurrentRecord) return this.getCurrentRecord.archiveId;
      if (this.getDefaultRecord) return this.getDefaultRecord.archiveId;
      return 0;
    },
    getSelectRecord(): RecordItem {
      if (this.getCurrentRecord) return this.getCurrentRecord;
      return this.getDefaultRecord;
    },
  },
  actions: {
    changeRecord(record: RecordItem) {
      this.defaultRecord = record;
      setRecord(record);
    },
    changeCurrentRecord(record: RecordItem) {
      this.currentRecord = record;
      setCurRecord(record);
    },
    updateForm(updates: Partial<RecordState['form']>) {
      const { form } = toRefs(this);
      Object.assign(form, updates);
    },
    async _getDefaultRecord() {
      try {
        const currentRecord = this.currentRecord || getCurRecord();
        const { data } = await getRecordById(currentRecord.archiveId);
        this.changeCurrentRecord(data);
      } catch (error) {
        console.log(error);
      }
    },
  },
});
